import { render } from "./CardStyle.vue?vue&type=template&id=74f50a58"
import script from "./CardStyle.vue?vue&type=script&lang=js"
export * from "./CardStyle.vue?vue&type=script&lang=js"
script.render = render

export default script